import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Star, ArrowRight } from 'lucide-react';
import './TourCard.css';

export default function TourCard({ tour }) {
  const { id, title, category, price, originalPrice, duration, rating, image, tag, shortDescription } = tour;

  return (
    <div className="tour-card glass-card">
      <div className="tour-card-image-wrapper">
        <img src={image} alt={title} className="tour-card-image" loading="lazy" />
        <span className={`tour-card-category-badge ${category.toLowerCase() === 'domestic' ? 'badge-domestic' : 'badge-international'}`}>
          {category}
        </span>
        {tag && (
          <span className="tour-card-tag-badge">
            {tag}
          </span>
        )}
      </div>

      <div className="tour-card-content">
        <div className="tour-card-header">
          <div className="tour-card-rating">
            <Star className="star-icon" size={16} />
            <span>{rating.toFixed(2)}</span>
          </div>
          <div className="tour-card-duration">
            <Calendar size={14} />
            <span>{duration.split('/')[0]}</span>
          </div>
        </div>

        <h3 className="tour-card-title">{title}</h3>
        <p className="tour-card-description">{shortDescription}</p>

        <div className="tour-card-footer">
          <div className="tour-card-price">
            {originalPrice && <span className="original-price">₹{originalPrice.toLocaleString('en-IN')}</span>}
            <span className="current-price">₹{price.toLocaleString('en-IN')}</span>
            <span className="price-label"> / person</span>
          </div>
          
          <div className="tour-card-actions">
            <Link to={`/tour/${id}`} className="tour-card-btn-details" aria-label={`View details of ${title}`}>
              Details <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
